<template>
  <v-app :style="{ background: $vuetify.theme.themes.dark.background }">
    <v-main>
      <router-view class="global-router"></router-view>
    </v-main>

  </v-app>
</template>

<script>
export default {
  name: "Layout",
  components: {},
  data:() => ({
    //logoImg: require('@/assets/logo.png'),
  }),
  methods:{},
  watch: {},
};
</script>

<style>


</style>
